/* eslint-disable no-console */
/* eslint-disable no-unused-vars */
/* eslint-disable no-use-before-define */
/* eslint-disable no-underscore-dangle */
import { userConstants } from '../constants/userConstants';
import userServices from '../services/userServices';
import teacherServices from '../services/teacherServices';
import { toastError } from './alertActions';

function login(username, password) {
  return (dispatch, getState) => {
    dispatch(loginRequest({ username }));
    userServices.login(username, password, false)
      .then(
        (logged) => {
          if (!logged || (logged.statusText && logged.statusText === 'KO')) {
            teacherServices.login(username, password, false)
              .then(
                (_logged) => {
                  if (_logged && _logged.statusText && _logged.statusText === 'KO') {
                    dispatch(loginFailure(_logged.data.message));
                    toastError(_logged.data.message);
                  } else {
                    userServices.generateLoginToken(_logged.data);
                    dispatch(loginSuccess(_logged.data));
                    const state = getState();
                    dispatch(getTeacher(state.authentication.auth._id, true));
                  }
                },
                (error) => {
                  toastError(error.toString());
                  dispatch(loginFailure(error.toString()));
                },
              );
          } else {
            userServices.generateLoginToken(logged.data);
            dispatch(loginSuccess(logged.data));
            const state = getState();
            dispatch(getUser(state.authentication.auth._id, true));
          }
        },
        (error) => {
          toastError(error.toString());
          dispatch(loginFailure(error.toString()));
          // dispatch(alertActions.error('Could not connect, please check your credentials.'));
        },
      );
  };

  function loginRequest() { return { type: userConstants.LOGIN_REQUEST }; }
  function loginSuccess(auth) { return { type: userConstants.LOGIN_SUCCESS, auth }; }
  function loginFailure(error) { return { type: userConstants.LOGIN_FAILURE, error }; }
}

function getUser(userId, log) {
  return (dispatch) => {
    dispatch(request(userId));
    userServices.getUserById(userId)
      .then(
        (user) => {
          if (!log) {
            sessionStorage.setItem('user', JSON.stringify(user));
          } else {
            localStorage.setItem('user', JSON.stringify(user));
          }
          dispatch(success(user));
        },
        (error) => {
          dispatch(failure(error.toString()));
          // dispatch(alertActions.error(error.toString()));
        },
      );
  };

  function request(user) { return { type: userConstants.GET_USER_REQUEST, user }; }
  function success(user) { return { type: userConstants.GET_USER_SUCCESS, user }; }
  function failure(error) { return { type: userConstants.GET_USER_FAILURE, error }; }
}

function getTeacher(userId, log) {
  return (dispatch) => {
    dispatch(request(userId));
    teacherServices.getTeacherById(userId)
      .then(
        (user) => {
          if (!log) {
            sessionStorage.setItem('user', JSON.stringify(user));
          } else {
            localStorage.setItem('user', JSON.stringify(user));
          }
          dispatch(success(user));
        },
        (error) => {
          dispatch(failure(error.toString()));
          //   dispatch(alertActions.error(error.toString()));
        },
      );
  };

  function request(user) { return { type: userConstants.GET_USER_REQUEST, user }; }
  function success(user) { return { type: userConstants.GET_USER_SUCCESS, user }; }
  function failure(error) { return { type: userConstants.GET_USER_FAILURE, error }; }
}

function refreshLogin(email) {
  return (dispatch, state) => {
    dispatch(refreshRequest({ email }));
    return userServices.refreshAuth(email, state().authentication.auth.refreshToken)
      .then(
        (logged) => {
          userServices.generateLoginToken(logged);
          dispatch(refreshSuccess(logged));
        },
        (error) => {
          dispatch(refreshFailure(error.toString()));
          // dispatch(alertActions.error(error.toString()));
        },
      );
  };

  function refreshRequest() { return { type: userConstants.LOGIN_REFRESH_REQUEST }; }
  function refreshSuccess(auth) { return { type: userConstants.LOGIN_REFRESH_SUCCESS, auth }; }
  function refreshFailure(error) { return { type: userConstants.LOGIN_REFRESH_FAILURE, error }; }
}

function logout() {
  return (dispatch) => {
    dispatch({ type: 'USERS_LOGGED_OUT' });
    userServices.logout();
  };
}

function forgotPassword(email) {
  return (dispatch) => {
    dispatch(passwordRequest({ email }));
    userServices.forgotPassword(email)
      .then(
        () => {
          dispatch(passwordSuccess());
        },
        (error) => {
          dispatch(passwordFailure(error.toString()));
          // dispatch(alertActions.error(error.toString()));
        },
      );
  };
  function passwordRequest(mail) { return { type: userConstants.REQUEST_NEW_PASSWORD, mail }; }
  function passwordSuccess() { return { type: userConstants.SUCCESS_NEW_PASSWORD }; }
  function passwordFailure(error) { return { type: userConstants.FAILURE_NEW_PASSWORD, error }; }
}

function updateStudent(userId, body) {
  return (dispatch) => {
    dispatch(refreshRequest(body));
    return userServices.updateStudent(userId, body)
      .then(
        () => {
          dispatch(refreshSuccess());
        },
        (error) => {
          dispatch(refreshFailure(error.toString()));
          // dispatch(alertActions.error(error.toString()));
        },
      );
  };
  function refreshRequest(data) { return { type: userConstants.REQUEST_UPDATE_USER, data }; }
  function refreshSuccess() { return { type: userConstants.SUCCESS_UPDATE_USER }; }
  function refreshFailure(error) { return { type: userConstants.FAILURE_UPDATE_USER, error }; }
}

function updateTeacher(userId, body) {
  return (dispatch) => {
    dispatch(refreshRequest(body));
    return userServices.updateTeacher(userId, body)
      .then(
        () => {
          dispatch(refreshSuccess());
        },
        (error) => {
          dispatch(refreshFailure(error.toString()));
          // dispatch(alertActions.error(error.toString()));
        },
      );
  };
  function refreshRequest(data) { return { type: userConstants.REQUEST_UPDATE_TEACHER, data }; }
  function refreshSuccess() { return { type: userConstants.SUCCESS_UPDATE_TEACHER }; }
  function refreshFailure(error) { return { type: userConstants.FAILURE_UPDATE_TEACHER, error }; }
}

function updateCustomer(userId, body) {
  return (dispatch) => {
    dispatch(refreshRequest(body));
    return userServices.updateCustomer(userId, body)
      .then(
        () => {
          dispatch(refreshSuccess());
        },
        (error) => {
          dispatch(refreshFailure(error.toString()));
          // dispatch(alertActions.error(error.toString()));
        },
      );
  };
  function refreshRequest(data) { return { type: userConstants.REQUEST_UPDATE_CUSTOMER, data }; }
  function refreshSuccess() { return { type: userConstants.SUCCESS_UPDATE_CUSTOMER }; }
  function refreshFailure(error) { return { type: userConstants.FAILURE_UPDATE_CUSTOMER, error }; }
}

const userActions = {
  login,
  logout,
  forgotPassword,
  getUser,
  refreshLogin,
  updateStudent,
  updateTeacher,
  updateCustomer,
  // delete: _delete
};

export default userActions;
